import { useEffect } from "react";
import { navigate } from "./Link";

export default function Redirect(props) {
    useEffect(() => {
        navigate(props.path, true);
    }, []);

    return null;
}
